import { twMerge } from 'tailwind-merge';

import { card } from '@/styles/styles';
import { SimplifiedCourseProgress } from '@/models/StudentCourseProgress';
import CourseProgressDisplay from './CourseProgressDisplay';
import useStudentContext from '@/data/hook/useStudentContext';
import NextLessonDisplay from './NextLessonDisplay';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import Klass from '@/models/Klass';

type Props = {
  courseProgrss: SimplifiedCourseProgress;
  klass?: Klass;
};

export default function CourseProgressNextLesson(props: Props) {
  const {
    selectProgress: onSelect,
    nextLesson,
    loadingNextLesson,
    otherCoursesStats,
  } = useStudentContext();

  const { courseProgrss, klass } = props;

  return (
    <article
      className={twMerge(
        card,
        'flex flex-col lg:flex-row gap-2.5 p-2 border-none w-full',
      )}
    >
      <CourseProgressDisplay
        key={courseProgrss.id}
        courseProgress={courseProgrss}
        onSelect={onSelect}
        collection={otherCoursesStats}
        banner
        progress
      />

      <ConditionalRenderer condition={nextLesson}>
        <hr className="border-t border-accent-content h-px lg:border-l lg:border-t-0 lg:h-auto lg:w-px" />
      </ConditionalRenderer>

      <NextLessonDisplay
        slugCourseName={courseProgrss.coursePath.slug}
        lesson={nextLesson?.lesson}
        klassId={nextLesson?.klass}
        loading={loadingNextLesson}
        date={nextLesson?.datetime}
        classroomUrl={nextLesson?.url ?? klass?.classRoomUrl}
      />
    </article>
  );
}
